'use client';

// imports
import { useState } from 'react';

// lib files
import { Franchise } from "@/lib/types/api/franchise-data";

// components
import BackButton from "@/components/Button/BackButton";
import ComponentTransition from '@/components/Transitions/ComponentTransition';
import ITSImage from "@/components/ITSImage/ITSImage";
import ITSPicture from '@/components/ITSPicture/ITSPicture';
import LinkButton from "@/components/Button/LinkButton";

// styles
import styles from './FranchiseHero.module.scss';
interface FranchiseHeroProps {
  franchise: Franchise;
  fallbackBackgroundImage?: string;
}
const maxWords = 25; // Display first 25 words
const wordsThreshold = 35; // Show "Show More" button if more than 35 words

const FranchiseHero: React.FC<FranchiseHeroProps> = props => {
  const {
    franchise,
    fallbackBackgroundImage
  } = props;
  const {
    images,
    title,
    links
  } = franchise;
  const descriptionToDisplay = franchise.description_long || franchise.description_short || null;
  const logoToShow = images['white-logo-41'] || images['franchise-white-logo'] || null;
  const producerLink = links.find(link => link.profile === 'producer');
  const backgroundImage = images['background'] || fallbackBackgroundImage;
  const [expanded, setExpanded] = useState(false);
  const descriptionWords = descriptionToDisplay?.replace(/<[^>]*>/g, '').split(/\s+/);
  const displayDescription = descriptionWords && descriptionWords.length > wordsThreshold ? descriptionWords.slice(0, maxWords).join(' ') + '...' : descriptionToDisplay;
  return <div className={styles.franchise_hero} data-sentry-component="FranchiseHero" data-sentry-source-file="FranchiseHero.tsx">
      <BackButton className={styles.franchise_hero_back_button} data-sentry-element="BackButton" data-sentry-source-file="FranchiseHero.tsx" />

      {backgroundImage && <div className={styles.franchise_hero_background_image}>
          <ComponentTransition>
            <ITSPicture src={backgroundImage} alt={title} width={1440} height={650} resizeWithCrop={true} sources={[{
          minWidth: 1280,
          width: 1280,
          height: 720
        }, {
          minWidth: 1024,
          width: 1024,
          height: 576
        }, {
          minWidth: 768,
          width: 768,
          height: 432
        }, {
          minWidth: 500,
          width: 500,
          height: 281
        }, {
          minWidth: 320,
          width: 320,
          height: 180
        }]} ariaHidden={true} className="franchise_hero_background" />

          </ComponentTransition>
        </div>}

      <div className={styles.franchise_hero_overlay}>
        <h1 className={styles.franchise_hero_name}>
          {logoToShow ? <ITSImage src={logoToShow} alt={title} width={300} /> : <>{title}</>}
        </h1>

      {descriptionToDisplay && <>
        <p className={`${styles.franchise_hero_description} ${styles.franchise_hero_description_expanding}`}>
          <span dangerouslySetInnerHTML={{
            __html: expanded ? descriptionToDisplay : displayDescription as string
          }} />
          {descriptionWords && descriptionWords.length > wordsThreshold && <button className={styles.franchise_hero_description_more_button} onClick={() => setExpanded(!expanded)}>
              {expanded ? `Less` : `More`}
            </button>}
        </p>
        <p className={`${styles.franchise_hero_description} ${styles.franchise_hero_description_full}`}>
          {descriptionToDisplay}
        </p>
        </>}

      {producerLink && <LinkButton href={producerLink.value} target="_blank" className={styles.franchise_hero_website_link}>
          Visit Official Site
        </LinkButton>}
      </div>
    </div>;
};
export default FranchiseHero;